import Pregunta from '@/models/Sobrevivencia/Pregunta';
import ServiceResponse from './ServiceResponse';

export default class ServiceResponseFormulario extends ServiceResponse {
    public data: Pregunta;
}